import WorkflowStorage from "../ABDMWorkflowStorage";
export function getValue(obj, path) {
    if (!obj || !path) return undefined;
    return path.split(".").reduce((current, key) => {
        if (current == null) return undefined;
        const match = key.match(/^(.+)\[(\d+)\]$/);
        if (match) {
            const name = match[1];
            const index = Number(match[2]);
            return current[name]?.[index];
        }
        return current[key];
    }, obj);
}
export function saveWorkflow(data, mapping = {}) {
    if (!data) return;
    // Automatic extraction
    if (data.txnId) WorkflowStorage.save("txnId", data.txnId);
    if (data.xToken) WorkflowStorage.save("xToken", data.xToken);
    if (data.tToken) WorkflowStorage.save("tToken", data.tToken);
    if (data.accessToken) WorkflowStorage.save("accessToken", data.accessToken);
    if (data.abhaNumber) WorkflowStorage.save("abhaNumber", data.abhaNumber);
    if (data.abhaAddress) WorkflowStorage.save("abhaAddress", data.abhaAddress);
    if (Array.isArray(data.ABHA)) {
        const item = data.ABHA[0];
        if (item?.index) WorkflowStorage.save("index", item.index);
        if (item?.ABHANumber) WorkflowStorage.save("abhaNumber", item.ABHANumber);
        if (item?.name) WorkflowStorage.save("name", item.name);
    }
    // NEW: custom mappings from FlowCard
    Object.entries(mapping).forEach(([storageKey, jsonPath]) => {
        const value = getValue(data, jsonPath);
        if (value !== undefined && value !== null) WorkflowStorage.save(storageKey, value);
    });
}